import { DbStoreItem } from "../../../data/usecases/store-item";
import { StoreItem } from "../../../domain/usecases/store-item";
import { makeAuthorizeHttpClientDecorator } from "../decorators";
import { makeApiUrl, makeAxiosHttpClient } from "../http";

export const makeDbStoreItem = (): StoreItem =>
  new DbStoreItem(makeApiUrl("/store"), makeAuthorizeHttpClientDecorator());
